import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import errorimg from "../../assets/images/error-img.png";
import "./Unauthorized.scss";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="error-pages pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-5">
                <h1 className="display-2 fw-medium">
                  4<span className="bx-spin"> </span>3
                </h1>
                <h4 className="text-uppercase">Access Denied</h4>
                <div className="mt-4 text-center">
                  <Button className="btn save-btn" onClick={() => navigate("/login")}>
                    Back to Login
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="justify-content-center row">
            <div className="col-md-8 col-xl-6">
              <div>
                <img src={errorimg} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forbidden;
